import { useEffect } from 'react'

import { FrankieOneKycComponent } from '@/onboarding/features/kyc/components/FrankieOneKycComponent'
import { useFrankieOneKycLogic } from '@/onboarding/features/kyc/useFrankieOneKycLogic'

export function FrankieOneKYCFlow() {
    const logic = useFrankieOneKycLogic()

    // Auto-start KYC on mount if not already started
    useEffect(() => {
        if (!logic.isKYCStart && !logic.isPending) {
            logic.startInitKyc()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logic.isKYCStart, logic.isPending, logic.startInitKyc])

    return (
        <FrankieOneKycComponent
            token={logic.token}
            isPending={logic.isPending}
            isError={logic.isError}
            error={logic.error}
            isSuccess={logic.isSuccess}
            isKYCStart={logic.isKYCStart}
            flowContext={logic.flowContext}
            onComplete={logic.onComplete}
        />
    )
}
